<hr>
<p ng-if="$ctrl.name">
  <b>{{$ctrl.name | capitalize}}</b>
</p>
<p>{{$ctrl.label}}</p>
